import React from "react";
import "./ModalView.css";

export default function ModalView({ children, isOpen, onClose}) {

    if (!isOpen) {
        return null;
    }


  return (
    <div className="modal">
    <div className="overlay"></div>
    <div className='modal-content'>
    {children}
    </div>
    </div>
  );
}